import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

import { accessLocalStorage, valuesAnalyze, changeViewForms, changeIpRoutes, readIpRoutes } from '../../../services';
import FormIPSet from './formIpSetInterfaces';

import '../../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function RoutesList() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, toggleIsChangeFormElements } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [routes, setDataRoutes] = useState([]);

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  /*
    [
      {
          "iface": "eth0",
          "srdest": "192.168.88.2",
          "mask": "255.255.255.0",
          "gw": "192.168.88.1"
      },
    ]
  */

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    const getDataRoutes = await readIpRoutes();
    
    const filterRoutes = getDataRoutes[0].filter((element) => !element.includes('kernel'));
    
    setDataRoutes(getDataRoutes[0]);
  }, []);

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div>
      <div className="columns has-text-centered">
        <div className="column is-half is-offset-one-quarter has-text-centered">
          <strong className="is-size-3">ADICIONAR ROTAS</strong>
          <hr className="dropdown-divider"/>
        </div>
      </div>
        <div className="columns is-fullwidth mx-2">
          <div className="column tabs is-flex-wrap-wrap is-full">
            <table id="tableCalls" className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">  
              <thead>
                <tr className='is-size-4 has-text-centered has-background-link-light'>
                  <th scope="col">Rotas</th>
                </tr>
            </thead>
            <tbody>
              {
                routes.map((route, index) => (
                  <tr key={ index } className='is-size-5 has-text-centered is-family-monospace'>
                    <td>{ route }</td>
                  </tr>
                ))
              }
              </tbody>
            </table>
          </div>
        </div>
    </div>
  );
}

export default RoutesList;
